import React, { useEffect } from 'react';
import {FORM, LAYOUT_ITEM, QUOTATION_DTO_FORM} from 'constants/FormConstants';
import { TextFieldLayoutItem, SelectLayoutItem, AttachmentLayoutItem } from 'models/InputLayoutItem';
import { RutValidator } from 'utils/RutValidator';
import * as yup from 'yup';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { DATA_LAYERS } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';
import { DataLayerMarkupProps } from 'models/props/DataLayerMarkupProps';
import { CreditLiquidationList } from '../../../../constants/CreditLiquidationList';

export const CreditLiquidationEntityInfoForm = ({ dataLayerKey }: DataLayerMarkupProps) => {
	const fields: any[] = [
		{
			defaultValue: CreditLiquidationList[0].value,
			label: 'Nombre institución financiera*',
			name: FORM.FINANCIAL_INSTITUTION_NAME,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: CreditLiquidationList,
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			label: 'Rut de la institución financiera*',
			defaultValue: '',
			name: QUOTATION_DTO_FORM.FINANCIAL_INSTITUTION_RUT,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: 12345678-9',
			mask: 'rut',
			validation: yup
				.string()
				.required('Campo Requerido')
				.min(8, 'ingrese un rut válido')
				.test('rut-valid', 'ingrese un rut válido', (value) => {
					return value !== undefined ? RutValidator(value) : false;
				}),
		} as TextFieldLayoutItem,
		{
			label: 'Email institución financiera*',
			defaultValue: '',
			name: FORM.EMAIL_INSTITUTION,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: mail@mail.cl',
			validation: yup.string().email('Ingrese un email válido').required('Campo Requerido'),
		} as TextFieldLayoutItem,
		{
			label: 'Número de operación*',
			defaultValue: '',
			name: QUOTATION_DTO_FORM.NUMBER_OPERATIONS,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: 81113333',
			validation: yup
				.string()
				.required('Campo Requerido')
				.matches(
					/^[0-9]+$/u,
					'Ingrese solo numeros'
				),
		} as TextFieldLayoutItem,
		{
			label: 'Solicitud de portabilidad (Formato: JPG o PDF)*',
			defaultValue: null,
			name: QUOTATION_DTO_FORM.ATTACHMENT,
			type: LAYOUT_ITEM.TYPE.FILE,
			accept: 'image/jpeg, application/pdf',
			validation: yup
				.mixed()
				.required('Campo Requerido')
				.test('fileType', 'Solo se permiten archivos JPG o PDF', (value) => {
					if (!value) return false;
					return ['image/jpeg', 'application/pdf'].includes(value.type);
				})
		} as AttachmentLayoutItem,
	];

	useEffect(
		() => {
			if (dataLayerKey) {
				TagManager.dataLayer({
					dataLayer: DATA_LAYERS.get(dataLayerKey),
				});
			}
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información de la entidad financiera"
				body="Completa los datos."
			/>
			<CreateFormLayout key={fields.length} fields={fields} />
		</div>
	);
};
